<template>
  <el-dialog class="dialog-volunteer-detail" :append-to-body="true" :visible.sync="dialogVisible" title="详情" width="1000px">
    <div class="wrap">
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">参与人 :</span>
              <span class="g-label-txt">{{detailData.name}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">报名时间 :</span>
              <span class="g-label-txt">{{detailData.createTime}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">联系方式 :</span>
              <span class="g-label-txt">{{detailData.phone}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">证件号 :</span>
              <span class="g-label-txt">{{detailData.identificationNumber}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">状态 :</span>
              <span class="g-label-txt">{{detailData.orderStatusName}}</span>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">所在学校 :</span>
              <span class="g-label-txt">{{detailData.school}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">身高 :</span>
              <span class="g-label-txt">{{detailData.high}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">体重 :</span>
              <span class="g-label-txt">{{detailData.weight}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">兴趣爱好 :</span>
              <span class="g-label-txt">{{detailData.interest}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="g-label-box mb-20">
              <span class="g-label-name">个人荣誉 :</span>
              <span class="g-label-txt">{{detailData.honor}}</span>
            </div>
          </el-col>

          
          <!-- <el-col :span="24">
            <div class="g-label-box mb-20">
              <span class="g-label-name">机构营业执照 :</span>
                <viewer class="g-label-txt" :options="{ url: 'data-maxUrl' }">
                  <img class="g-pointer" :src="detailData.orgPicture"
                    :data-maxUrl="detailData.orgPicture" alt :onerror="defaultImg"
                    style="width: 150px;">
                </viewer>
            </div>
          </el-col> -->

          <!-- <el-col :span="24">
            <div class="g-label-box mb-20">
              <span class="g-label-name">身份证照片 :</span>
              <viewer class="g-label-txt" :options="{ url: 'data-maxUrl' }">
                <img class="g-pointer" :src="detailData.idcardPicFront"
                  :data-maxUrl="detailData.idcardPicFront" alt :onerror="defaultImg"
                  style="width: 150px;">

                <img class="g-pointer" :src="detailData.idcardPicBack"
                  :data-maxUrl="detailData.idcardPicBack" alt :onerror="defaultImg"
                  style="width: 150px;margin-left: 20px;">
              </viewer>
            </div>
          </el-col> -->
        </el-row>
    </div>

    <!-- 审批状态 0 待审批 1 已通过 2 已拒绝 -->
    <!-- <div slot="footer" class="footer mt-30" v-if="detailData.approveStatus === '0'">
      <el-button @click="handleClick('refuse')">拒绝</el-button>
      <el-button @click="handleClick('ok')" type="primary" :loading="loadingSave">审批通过</el-button>
    </div> -->


    <div slot="footer" class="footer mt-30">
      <el-button @click="dialogVisible=false">关闭</el-button>
    </div>

    <!-- <dialogArea ref="dialogArea" :approveTitle="'审批'" @closePanel="closePanel"></dialogArea> -->
  </el-dialog>
</template>

<script>
// import dialogArea from './dialog-area' // 审批面板
export default {
  // components: {
  //   dialogArea
  // },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      pageType: '', // deital 详情 check 审核
      activeName: '1',
      dialogVisible: false,
      form: {},
      detailId: '',
      detailData: {},
      loadingSave: false
    }
  },
  methods: {
    init(item, type) {
      this.detailId = item.id
      this.pageType = type
      this.dialogVisible = true

      this.getDetail()
    },
    getDetail() {
      this.$http.get('/activitynew/personal/training/orderUserExtInfo', {
        id: this.detailId
      }).then(res => {
        if (res.success) {
          this.detailData = res.result || {}
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleClick(type) {
      this.$refs.dialogArea.init(this.detailId, type)
    },
    handleClickTab() {
      switch (this.activeName) {
        case '1':
          this.getDetail()
          break
        default:
          break
      }
    }, 
    closePanel() {
      this.$emit('refresh')
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-volunteer-detail {
  .wrap {
    // height: 420px;
  }
}
</style>
